import React from "react";
import { useEffect, useState } from "react";
import {
    Container,
    Grid,
    Loader,
    Text,
    Image,
    Stack,
    Title,
    Center,
    Divider,
    AspectRatio,
    Box,
    Flex,
    SimpleGrid,
} from "@mantine/core";
import GoogleMap from "../../Components/map_react";
import { Animate } from "react-simple-animate";
import { useViewportSize } from "@mantine/hooks";
import parse from "html-react-parser";

/**
 * This view component will be rendered when visiting /pages/greet
 * when your application has been setup with inertiajs.
 */
export default function Highlights(props) {
    const [highlights, setHighlights] = useState(null);
    const [tour, setTour] = useState(props.tour);
    const { height, width } = useViewportSize();

    console.log(tour);
    var test = [];
    useEffect(() => {
        console.log(tour);
        var lights = [];
        var odd = true;
        tour.stops.map((stop, index) => {
            odd = !odd;
            lights.push(
                <Box key={stop._joinData.id}>
                    <Grid
                        bg={odd ? "grey.0" : "grey.1"}
                        key={stop._joinData.id}
                    >
                        <Grid.Col span={{ base: 12, md: 8 }}>
                            <Container>
                                <Title>
                                    Day {stop._joinData.tour_day} - {stop.name}
                                </Title>
                                <Text lineClamp={6}>
                                    {parse(stop.description)}
                                </Text>
                            </Container>
                        </Grid.Col>
                        <Grid.Col span={{ base: 12, md: 4 }} p={0}>
                            <Container fluid p={0}>
                                <AspectRatio
                                    ratio={16 / 9}
                                    maw={"100%"}
                                    mx="auto"
                                >
                                    <Image
                                        src={`https://www.best-scottish-tours.co.uk/Plugin/Stops/assets/image/${stop.image}`}
                                    />
                                </AspectRatio>
                            </Container>
                        </Grid.Col>
                    </Grid>
                    <Divider size={6} color="gray.0" />
                </Box>,
            );
        });
        setHighlights(lights);
    }, []);
    return (
        <Grid h={height - 163} p={0} pt={25}>
            <Grid.Col
                span={{ base: 12, md: 8 }}
                style={{ overflowY: "scroll" }}
            >
                <Animate
                    play={true}
                    start={{
                        transform: "translateX(-100px)",
                        opacity: 0.1,
                    }}
                    end={{ transform: "translateX(0px)", opacity: 1 }}
                    easeType="ease-in"
                    duration={0.3}
                    delay={0}
                >
                    {highlights}
                </Animate>
            </Grid.Col>

            <Grid.Col pb={0} span={{ base: 12, md: 4 }}>
                <Stack gap={0} h={"100%"}>
                    <Flex justify="flex-end" direction="column" h={"25%"}>
                        <Container>
                            <Title fz={50}>
                                Your Tour
                                <br /> Highlights
                            </Title>
                        </Container>
                    </Flex>
                    <Center h={"25%"}>
                        <Divider
                            h={"100%"}
                            color="purple.0"
                            orientation="vertical"
                            size="sm"
                        />
                    </Center>
                    <Container pb={0} h={"50%"} w={"100%"}>
                        <GoogleMap tour={props.tour.tour.tour_days}></GoogleMap>
                    </Container>
                </Stack>
            </Grid.Col>
        </Grid>
    );
}
